import React from 'react'
import { Card, CardHeader, CardTitle } from '@duck/ui'

interface CohortPeopleListSkeletonProps {
  listTitle: string
}

export const CohortPeopleListSkeleton: React.FC<CohortPeopleListSkeletonProps> = ({ listTitle }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{listTitle}</CardTitle>
      </CardHeader>
      <div className="overflow-x-auto rounded-lg animate-pulse">
        <table className="min-w-full divide-y divide-border">
          <thead className="bg-secondary/5">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                <div className="h-4 bg-muted rounded w-24"></div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                <div className="h-4 bg-muted rounded w-32"></div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                <div className="h-4 bg-muted rounded w-28"></div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                <div className="h-4 bg-muted rounded w-20"></div>
              </th>
            </tr>
          </thead>
          <tbody className="bg-card divide-y divide-border">
            {[...Array(5)].map((_, i) => (
              <tr key={i}>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="h-4 bg-muted rounded w-32"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="h-4 bg-muted rounded w-40"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="h-6 bg-muted rounded w-20"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="h-4 bg-muted rounded w-24"></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  )
}
